<!-- //
文件日志内容预览
@author xuyd
@date 2024-08-07
//-->
<template>
  <page-layout layout="C">
    <div style="height: 100%">
      <div class="layout-search flex-row flex-halign-between">
        <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
                 label-width="100px">
          <el-form-item prop="search">
            <el-input
                v-model="queryParams.search"
                placeholder="请输入检索内容"
                style="width: 320px;text-align: right;"
                maxlength="20"
                clearable
                @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <div class="flex-row">
              <div>
                <el-button type="primary" @click="handleQuery" icon="el-icon-search" :loading="loading">检索</el-button>
              </div>
              <el-pagination
                  background
                  @current-change="getList"
                  @size-change="getList"
                  :page-sizes="[50, 100, 200, 300]"
                  :total="total"
                  :current-page.sync="queryParams.pageNum"
                  :page-size.sync="queryParams.pageSize"
                  layout="sizes, prev, pager, next">
              </el-pagination>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="layout-result"
           style="width: 100%; height: calc(100% - 50px); padding: 0 10px 10px 0; overflow-y: hidden">
        <MonacoEditor v-model="form.content" :options="codeOptions" style="background-color: #222222; "/>
      </div>
    </div>
  </page-layout>
</template>

<script>

import MonacoEditor from '@/components/Editor/monacoEditor.vue'
import LogGrepApi from '@/api/sys/sysFileLog.api.js';

export default {
  name: 'ViewMonitorFileLog',
  components: {MonacoEditor},
  dictTypes: [
    // {dictType: "SERVICE_LIST", dataType: String},
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        serverIp: null,
        serveName: null,
        search: null,
      },
      loading: false,
      total: 0,
      codeOptions: {languageGroup: 'shell', language: 'shell', readOnly: true, minimap: {enabled: false}},
      form: {
        content: ""
      }
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          id: null,
          serverIp: null,
          serveName: null,
          logFileName: null,
        }
      }
    },
  },
  mounted() {
    this.queryParams = {...this.queryParams, ...this.data };
    this.handleQuery();
  },
  methods: {
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    getList() {
      this.loading = true;
      LogGrepApi.searchFileLogContent(this.queryParams).then(resp => {
        this.loading = false;
        this.form.content = resp.data.records || '';
        this.total = resp.data.total;
      }).catch(err => {
        this.loading = false;
      })
    },
  }
}
</script>

<style lang="less" scoped>

</style>
